
(function() {
  var result = { translations: { "ro": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Albanez\u0103", "sq-al": "Albanez\u0103 - Albania", "ar": "Arab\u0103", "ar-dz": "Arab\u0103 - Algeria", "ar-bh": "Arab\u0103 - Bahrain", "ar-eg": "Arab\u0103 - Egipt", "ar-iq": "Arab\u0103 - Irak", "ar-jo": "Arab\u0103 - Iordania", "ar-kw": "Arab\u0103 - Kuweit", "ar-lb": "Arab\u0103 - Liban", "ar-ly": "Arab\u0103 - Libia", "ar-ma": "Arab\u0103 - Maroc", "ar-om": "Arab\u0103 - Oman", "ar-qa": "Arab\u0103 - Qatar", "ar-sa": "Arab\u0103 - Arabia Saudit\u0103", "ar-sd": "Arab\u0103 - Sudan", "ar-sy": "Arab\u0103 - Siria", "ar-tn": "Arab\u0103 - Tunisia", "ar-ae": "Arab\u0103 - Emiratele Arabe Unite", "ar-ye": "Arab\u0103 - Yemen", "as": "Assamez\u0103", "az": "Azerbaidjan", "hy": "Armean\u0103", "eu": "Basc\u0103", "be": "Bielorus\u0103", "be-by": "Bielorus\u0103 - Belarus", "bn": "Bengalez\u0103", "bg": "Bulgar\u0103", "bg-bg": "Bulgar\u0103 - Bulgaria", "bs": "Bosniac\u0103", "ca": "Catalan\u0103", "ca-es": "Catalan\u0103 - Catalonia", "zh": "Chinez\u0103", "zh-cn": "Chinez\u0103 - Simplificat\u0103", "zh-hk": "Chinez\u0103 - Hong Kong", "zh-mo": "Chinez\u0103 - Macau", "zh-sg": "Chinez\u0103 - Singapore", "zh-tw": "Chinez\u0103 - Tradi\u021Bional\u0103", "zh-chs": "Chinez\u0103 (Simplificat\u0103)", "zh-cht": "Chinez\u0103 (Tradi\u021Bional\u0103)", "zh-hans": "Chinez\u0103 (Han simplificat)", "zh-hant": "Chinez\u0103 (Han tradi\u021Bional)", "hr": "Croat\u0103", "hr-hr": "Croat\u0103 - Croa\u021Bia", "cs": "Ceh\u0103", "cs-cz": "Ceh\u0103 - Republica Ceh\u0103", "da": "Danez\u0103", "da-dk": "Danez\u0103 - Danemarca", "nl": "Olandez\u0103", "nl-be": "Olandez\u0103 - Belgia", "nl-ch": "Olandez\u0103 - Elve\u021Bia", "nl-lu": "Olandez\u0103 - Luxemburg", "nl-nl": "Olandez\u0103 - \u021A\u0103rile de Jos", "en": "Englez\u0103", "en-ae": "Englez\u0103 - Emiratele Arabe Unite", "en-au": "Englez\u0103 - Australia", "en-be": "Englez\u0103 - Belgia", "en-ca": "Englez\u0103 - Canada", "en-ch": "Englez\u0103 - Elve\u021Bia", "en-cn": "Englez\u0103 - China", "en-de": "Englez\u0103 - Germania", "en-es": "Englez\u0103 - Spania", "en-ee": "Englez\u0103 - Estonia", "en-fr": "Englez\u0103 - Fran\u021Ba", "en-hk": "Englez\u0103 - Hong Kong", "en-in": "Englez\u0103 - India", "en-ie": "Englez\u0103 - Irlanda", "en-ke": "Englez\u0103 - Kenya", "en-lu": "Englez\u0103 - Luxemburg", "en-my": "Englez\u0103 - Malaysia", "en-mt": "Englez\u0103 - Malta", "en-mx": "Englez\u0103 - Mexic", "en-nl": "Englez\u0103 - Olanda", "en-nz": "Englez\u0103 - Noua Zeeland\u0103", "en-ph": "Englez\u0103 - Filipine", "en-pk": "Englez\u0103 - Pakistan", "en-se": "Englez\u0103 - Suedia", "en-sg": "Englez\u0103 - Singapore", "en-tn": "Englez\u0103 - Tunisia", "en-za": "Englez\u0103 - Africa de Sud", "en-gb": "Englez\u0103 - Regatul Unit", "en-us": "Englez\u0103 - Statele Unite ale Americii", "en-zw": "Englez\u0103 - Zimbabwe", "et": "Estonian\u0103", "et-ee": "Estonian\u0103 - Estonia", "fo": "Feroez\u0103", "fa": "Farsi", "fi": "Finlandez\u0103", "fi-fi": "Finlandez\u0103 - Finlanda", "fil": "Filipinez\u0103", "fr": "Francez\u0103", "fr-be": "Francez\u0103 - Belgia", "fr-ca": "Francez\u0103 - Canada", "fr-fr": "Francez\u0103 - Fran\u021Ba", "fr-lu": "Francez\u0103 - Luxemburg", "fr-mc": "Francez\u0103 - Monaco", "fr-ch": "Francez\u0103 - Elve\u021Bia", "fr-tn": "Francez\u0103 - Tunisia", "gl": "Galician\u0103", "ka": "Georgian\u0103", "de": "German\u0103", "de-at": "German\u0103 - Austria", "de-de": "German\u0103 - Germania", "de-gr": "German\u0103 - Grecia", "de-li": "German\u0103 - Liechtenstein", "de-lu": "German\u0103 - Luxemburg", "de-ch": "German\u0103 - Elve\u021Bia", "el": "Greac\u0103", "el-cy": "Greac\u0103 - Cipru", "el-gr": "Greac\u0103 - Grecia", "gu": "Gujarati", "haw": "Hawaiian\u0103", "ha": "Hausa", "he": "Ebraic\u0103", "he-il": "Ebraic\u0103 - Israel", "iw-il": "Ebraic\u0103 - Israel", "hi": "Hindi", "hi-in": "Hindi - India", "hu": "Maghiar\u0103", "hu-hu": "Maghiar\u0103 - Ungaria", "is": "Islandez\u0103", "is-is": "Islandez\u0103 - Islanda", "id": "Indonezian\u0103", "in-id": "Indonezian\u0103 - Indonezia", "ga": "Irlandez\u0103", "ga-ie": "Irlandez\u0103 - Irlanda", "it": "Italian\u0103", "it-it": "Italian\u0103 - Italia", "it-ch": "Italian\u0103 - Elve\u021Bia", "ja": "Japonez\u0103", "ja-jp": "Japonez\u0103 - Japonia", "kn": "Kannada", "kk": "Kazah\u0103", "kok": "Konkani", "ko": "Coreean\u0103", "ko-kr": "Coreean\u0103 - Coreea de Sud", "ku": "Kurd\u0103", "ky": "Kirghiz\u0103", "ky-kg": "Kirghiz\u0103", "lo": "Lao", "lv": "Leton\u0103", "lv-lv": "Leton\u0103 - Letonia", "lt": "Lituanian\u0103", "lt-lt": "Lituanian\u0103 - Lituania", "mk": "Macedonean\u0103", "mk-mk": "Macedonean\u0103 - Macedonia", "ml": "Malayalam", "ms": "Malaiez\u0103", "ms-bn": "Malaiezian\u0103 - Brunei", "ms-my": "Malaiezian\u0103 - Malaysia", "mt": "Maltez\u0103", "mt-mt": "Maltez\u0103 - Malta", "mr": "Marathi", "mn": "Mongol\u0103", "my": "Birman\u0103", "my-mm": "Birman\u0103 - Myanmar (Burma)", "ne": "Nepali", "no": "Norvegian\u0103", "nb": "Bokmal norvegian\u0103", "nb-no": "Norvegian\u0103 Bokmal - Norvegia", "no-no": "Norvegian\u0103 - Norvegia", "pl": "Polonez\u0103", "pl-pl": "Polonez\u0103 - Polonia", "pt": "Portughez\u0103", "pt-br": "Portughez\u0103 - Brazilia", "pt-pt": "Portughez\u0103 - Portugalia", "pa": "Punjab\u0103", "pa-in": "Punjabi - India", "pa-pk": "Punjabi - Pakistan", "ro": "Rom\xE2n\u0103", "ro-ro": "Rom\xE2n\u0103 - Rom\xE2nia", "ru": "Rus\u0103", "ru-ru": "Rus\u0103 - Rusia", "rw-rw": "Kinyarwanda", "sa": "Sanscrit\u0103", "si": "Sinhala", "sr": "S\xE2rb\u0103", "sr-ba": "S\xE2rb\u0103 - Bosnia \u0219i Her\u021Begovina", "sr-me": "S\xE2rb\u0103 - Muntenegru", "sr-rs": "S\xE2rb\u0103 - Serbia", "sr-cs": "S\xE2rb\u0103 - Serbia \u0219i Muntenegru (fost\u0103)", "sk": "Slovac\u0103", "sk-sk": "Slovac\u0103 - Slovacia", "sl": "Sloven\u0103", "sl-si": "Sloven\u0103 - Slovenia", "es": "Spaniol\u0103", "es-ar": "Spaniol\u0103 - Argentina", "es-bo": "Spaniol\u0103 - Bolivia", "es-cl": "Spaniol\u0103 - Chile", "es-co": "Spaniol\u0103 - Columbia", "es-cr": "Spaniol\u0103 - Costa Rica", "es-cu": "Spaniol\u0103 - Cuba", "es-do": "Spaniol\u0103 - Republica Dominican\u0103", "es-ec": "Spaniol\u0103 - Ecuador", "es-sv": "Spaniol\u0103 - El Salvador", "es-gt": "Spaniol\u0103 - Guatemala", "es-hn": "Spaniol\u0103 - Honduras", "es-mx": "Spaniol\u0103 - Mexic", "es-ni": "Spaniol\u0103 - Nicaragua", "es-pa": "Spaniol\u0103 - Panama", "es-py": "Spaniol\u0103 - Paraguay", "es-pe": "Spaniol\u0103 - Peru", "es-pr": "Spaniol\u0103 - Puerto Rico", "es-es": "Spaniol\u0103 - Spania", "es-us": "Spaniol\u0103 - Statele Unite ale Americii", "es-uy": "Spaniol\u0103 - Uruguay", "es-ve": "Spaniol\u0103 - Venezuela", "sw": "Swahili", "sv": "Suedez\u0103", "sv-fi": "Suedez\u0103 - Finlanda", "sv-se": "Suedez\u0103 - Suedia", "sy": "Siriac\u0103", "ta": "Tamil\u0103", "tt": "T\u0103tar\u0103", "te": "Telugu", "th": "Thailandez\u0103", "th-th": "Thailandez\u0103 - Thailanda", "tl": "Tagalog", "tr": "Turc\u0103", "tr-tr": "Turc\u0103 - Turcia", "uk": "Ucrainean\u0103", "uk-ua": "Ucrainean\u0103 - Ucraina", "ur": "Urdu", "uz": "Uzbec", "vi": "Vietnamez\u0103", "vi-vn": "Vietnamez\u0103 - Vietnam", "yi": "Yiddish", "zu": "Zulu" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.161",
    "ar-eg": "static-1.161",
    "ar-sa": "static-1.161",
    "ar": "static-1.161",
    "be": "static-1.161",
    "bg": "static-1.161",
    "bn": "static-1.161",
    "ca-es": "static-1.161",
    "ca": "static-1.161",
    "cs": "static-1.161",
    "da": "static-1.161",
    "de": "static-1.161",
    "el": "static-1.161",
    "en-gb": "static-1.161",
    "en": "static-1.161",
    "es-ar": "static-1.161",
    "es-es": "static-1.161",
    "es-mx": "static-1.161",
    "es": "static-1.161",
    "et": "static-1.161",
    "eu": "static-1.161",
    "fi": "static-1.161",
    "fr-ca": "static-1.161",
    "fr": "static-1.161",
    "gl": "static-1.161",
    "gu": "static-1.161",
    "he-il": "static-1.161",
    "he": "static-1.161",
    "hi": "static-1.161",
    "hr": "static-1.161",
    "hu": "static-1.161",
    "hy": "static-1.161",
    "id": "static-1.161",
    "is": "static-1.161",
    "it": "static-1.161",
    "ja": "static-1.161",
    "ka": "static-1.161",
    "kk": "static-1.161",
    "kn": "static-1.161",
    "ko": "static-1.161",
    "ky": "static-1.161",
    "lt": "static-1.161",
    "lv": "static-1.161",
    "mk": "static-1.161",
    "mn": "static-1.161",
    "mr": "static-1.161",
    "ms-my": "static-1.161",
    "ms": "static-1.161",
    "nl-be": "static-1.161",
    "nl-nl": "static-1.161",
    "nl": "static-1.161",
    "no": "static-1.161",
    "pl": "static-1.161",
    "pt-br": "static-1.161",
    "pt-pt": "static-1.161",
    "ro": "static-1.161",
    "ru": "static-1.161",
    "sk": "static-1.161",
    "sl": "static-1.161",
    "sq": "static-1.161",
    "sr": "static-1.161",
    "sv": "static-1.161",
    "sw": "static-1.161",
    "ta": "static-1.161",
    "te": "static-1.161",
    "th": "static-1.161",
    "tl": "static-1.161",
    "tr": "static-1.161",
    "uk": "static-1.161",
    "ur": "static-1.161",
    "vi": "static-1.161",
    "zh-cn": "static-1.161",
    "zh-hans": "static-1.161",
    "zh-hant": "static-1.161",
    "zh-hk": "static-1.161",
    "zh-tw": "static-1.161"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "ro": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} ore", "hoursAndMinutes": "{{ hours }} ore {{ minutes }} min", "days": "{{ days }} zile", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}z", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ro": "static-7.1359"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1359",
    "ar-eg": "static-7.1359",
    "bg": "static-7.1359",
    "bn": "static-7.1359",
    "ca-es": "static-7.1359",
    "cs": "static-7.1359",
    "da": "static-7.1359",
    "de": "static-7.1359",
    "el": "static-7.1359",
    "en-gb": "static-7.1359",
    "en": "static-7.1359",
    "es-mx": "static-7.1359",
    "es": "static-7.1359",
    "et": "static-7.1359",
    "fi": "static-7.1359",
    "fr-ca": "static-7.1359",
    "fr": "static-7.1359",
    "he-il": "static-7.1359",
    "hi": "static-7.1359",
    "hr": "static-7.1359",
    "hu": "static-7.1359",
    "id": "static-7.1359",
    "it": "static-7.1359",
    "ja": "static-7.1359",
    "ko": "static-7.1359",
    "lt": "static-7.1359",
    "ms": "static-7.1359",
    "nl": "static-7.1359",
    "no": "static-7.1359",
    "pl": "static-7.1359",
    "pt-br": "static-7.1359",
    "pt-pt": "static-7.1359",
    "ro": "static-7.1359",
    "ru": "static-7.1359",
    "sk": "static-7.1359",
    "sl": "static-7.1359",
    "sv": "static-7.1359",
    "th": "static-7.1359",
    "tl": "static-7.1359",
    "tr": "static-7.1359",
    "uk": "static-7.1359",
    "vi": "static-7.1359",
    "x-pseudo": "static-7.1359",
    "zh-cn": "static-7.1359",
    "zh-hk": "static-7.1359",
    "zh-tw": "static-7.1359"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ro', {version: 'static-7.1359'}); }
})();



(function() {
  var result = { translations: { "ro": { "videoPlayer": { "htmlTitle": "Videoclip HubSpot", "htmlTitleWithVideo": "{{ videoTitle }} | Videoclip HubSpot", "controls": { "audioPlayer": "Player audio", "videoPlayer": "Player video", "play": "Redare", "playVideo": "Redare videoclip", "pause": "Pauz\u0103", "replay": "Reluare", "currentTime": "Timpul curent", "duration": "Durata", "remainingTime": "Timp r\u0103mas", "fullscreen": "Ecran complet", "exitFullscreen": "Ie\u0219ire din ecran complet", "mute": "Oprire sunet", "unmute": "Pornire sunet", "volumeLevel": "Nivel volum", "captions": "Legende", "captionsOff": "Dezactivat", "seekBar": "Ajustare pozi\u021Bie", "chapter": "Capitol", "elapsedTime": "Timp scurs: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Op\u021Biuni de redare", "playbackRate": "Vitez\u0103 de redare:", "quality": "Calitate:", "normal": "Normal\u0103", "auto": "(Auto)" }, "formModal": { "defaultThankYouMessage": "V\u0103 mul\u021Bumim pentru r\u0103spuns!", "inlineMessageButton": "Vizionare videoclip" }, "ctaModal": { "imgAlt": "CTA video" }, "errors": { "generic": { "heading": "Nu s-a putut \xEEnc\u0103rca videoclipul" }, "UNAUTHORIZED": { "heading": "Videoclipul nu a fost activat" }, "VIDEO_NOT_FOUND": { "heading": "Videoclipul nu a fost g\u0103sit" }, "INVALID_URL": { "heading": "Videoclipul nu a fost g\u0103sit" }, "UNSUPPORTED_EMBED": { "heading": "Videoclip indisponibil", "extra": "Acest videoclip nu poate fi vizionat extern." }, "refreshLink": "\xCEncerca\u021Bi din nou" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "ro": "static-1.29208"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.29208",
    "ar-eg": "static-1.29208",
    "bg": "static-1.29208",
    "bn": "static-1.29208",
    "ca-es": "static-1.29208",
    "cs": "static-1.29208",
    "da": "static-1.29208",
    "de": "static-1.29208",
    "el": "static-1.29208",
    "en-gb": "static-1.29208",
    "en": "static-1.29208",
    "es-mx": "static-1.29208",
    "es": "static-1.29208",
    "et": "static-1.29208",
    "fi": "static-1.29208",
    "fr-ca": "static-1.29208",
    "fr": "static-1.29208",
    "he-il": "static-1.29208",
    "hi": "static-1.29208",
    "hr": "static-1.29208",
    "hu": "static-1.29208",
    "id": "static-1.29208",
    "it": "static-1.29208",
    "ja": "static-1.29208",
    "ko": "static-1.29208",
    "lt": "static-1.29208",
    "ms": "static-1.29208",
    "nl": "static-1.29208",
    "no": "static-1.29208",
    "pl": "static-1.29208",
    "pt-br": "static-1.29208",
    "pt-pt": "static-1.29208",
    "ro": "static-1.29208",
    "ru": "static-1.29208",
    "sk": "static-1.29208",
    "sl": "static-1.29208",
    "sv": "static-1.29208",
    "th": "static-1.29208",
    "tl": "static-1.29208",
    "tr": "static-1.29208",
    "uk": "static-1.29208",
    "vi": "static-1.29208",
    "zh-cn": "static-1.29208",
    "zh-hk": "static-1.29208",
    "zh-tw": "static-1.29208"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:ro', {version: 'static-1.29208'}); }
})();


